import { render, staticRenderFns } from "./car_types_information.vue?vue&type=template&id=9f7797ae&scoped=true&"
import script from "./car_types_information.vue?vue&type=script&lang=js&"
export * from "./car_types_information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7797ae",
  null
  
)

export default component.exports